









































import { Component, Watch } from 'vue-property-decorator'
import { ProductIssueListModule } from '@/store/Products/ProductIssueListModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductIssue from '@/models/Products/ProductIssues/ProductIssue';
import ProductIssueState from '@/components/Products/ProductIssues/ProductIssueState.vue';
import ProductIssueFilterDialog from '@/components/Products/ProductIssues/ProductIssueFilterDialog.vue';

@Component({ name: 'ProductIssuesList', components: { Alert, ProductIssueState, ProductIssueFilterDialog }, metaInfo: { title: 'Product Issues' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.productIssues.fields.name'), sortable: false, width: '20%' },
        { text: this.$t('pageText.productIssues.fields.issueNumber'), sortable: false, width: '10%' },
        { text: this.$t('pageText.products.fields.type'), sortable: false, width: '10%' },
        { text: this.$t('pageText.products.fields.subType'), sortable: false, width: '15%' },
        { text: this.$t('pageText.products.fields.targetCustomerType'), sortable: false, width: '15%' },
        { text: this.$t('pageText.products.fields.product'), sortable: false, width: '20%' },
        { text: this.$t('pageText.productIssues.fields.state'), sortable: false, width: '10%' },
    ];
    productIssuesPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.productIssuesPage = +page;
        }
    }

    async beforeMount() {
        ProductIssueListModule.getProductIssues(this.productIssuesPage);
    }

    get productIssues() {
        return ProductIssueListModule.productIssues;;
    }

    get totalProductIssuesPages() {
        return ProductIssueListModule.totalProductIssuesPages;
    }

    get loading() {
        return ProductIssueListModule.loading;
    }

    get pageSize() {
        return ProductIssueListModule.pageSize;
    }

    get filterByProductType() {
        return ProductIssueListModule.filterByProductType;
    }

    get filterByProductSubType() {
        return ProductIssueListModule.filterByProductSubType;
    }

    get filterByProductIssueState() {
        return ProductIssueListModule.filterByProductIssueState;
    }

    @Watch('productIssuesPage')
    async onProductIssuesPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.productIssuesPage}` } });
        // Get new product issues
        await ProductIssueListModule.getProductIssues(this.productIssuesPage);
    }

    async navigateToProductIssue(productIssue: ProductIssue) {
        this.$router.push({ name: PageNames.ProductIssue, params: { id: productIssue.id }, query: { tab: "0" } });
    }

}
